import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';
import auth from '../../../auth/';

// import Detail from './Detail.js';

import { Row, Col } from 'reactstrap';

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/"
import ParadigmaTable from "../../../components/ParadigmaTable/"

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import dateFunctions from '../../functions/dateFunctions';

class Imputaciones extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            filter: [],
            usuarios: [],
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Fecha",
                    id: "fechaDeFacturacion",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaDeFacturacion),
                    show: true,
                    filterable: false,
                    Filter: ({ filter, onChange }) =>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'startDate' }}
                            value={this.state.startDate}
                            onChange={
                                date => {
                                    this.setState({ startDate: date });
                                    onChange(moment(date).format('YYYY-MM-DD HH:mm'));
                                }
                            }
                        />

                },
                {
                    Header: "Fecha",
                    id: "fechaDeCobro",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaDeCobro),
                    show: true,
                    filterable: false,
                    Filter: ({ filter, onChange }) =>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'startDate' }}
                            value={this.state.startDate}
                            onChange={
                                date => {
                                    this.setState({ startDate: date });
                                    onChange(moment(date).format('YYYY-MM-DD HH:mm'));
                                }
                            }
                        />

                },
                {
                    Header: "Cod Proyectos",
                    id: "nroProyecto",
                    accessor: d => d.nroProyecto,
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Cliente",
                    id: "empresa_nombre",
                    accessor: d => d.empresa_nombre,
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Porcentaje",
                    id: "porcentaje",
                    accessor: d => dateFunctions.formatCurrency(d.porcentaje),
                    className: 'text-right',
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Monto",
                    id: "monto",
                    accessor: d => dateFunctions.formatCurrency(d.monto),
                    className: 'text-right',
                    show: true,
                    filterable: false,
                },
            ]
        };
    }

    onChangeUsuario(data) {
        let filter = [];
        filter.push({ 'id': 'user_id', 'value': data.map(x => x.pk).join(',') });
        this.setState({ usuarios: data.map(x => x.pk), filter: filter });
    }

    render() {
        const { data, pages, loading } = this.state;
        let outerFilter = this.state.filter
        if(localStorage.iduser && !localStorage.permisos.includes('superadmin')){
            outerFilter.push({
                id: 'user_id',
                value: localStorage.permisos.includes('superadmin') ? (99999) : (localStorage.iduser),
            })
        }

        return (
            <ParadigmaTable
                buttons={[
                    // {
                    //     detail: true,
                    //     permission: 'solicitudes_view',
                    //     component: Detail,
                    // },
                ]}
                // customSearchElement={(!auth.hasPermission('administrador') ? <Row></Row> :
                //     <Row className={"px-0"}>
                //         <Col className={"mimicTableHeader"}>
                //             <ParadigmaLabeledInput labelColumns={1} fieldColumns={11} label={"Usuarios"}
                //                 inputComponent={
                //                     <ParadigmaAsyncSeeker
                //                         fieldName={""}
                //                         multiselect={true}
                //                         nombreField={"fullname"} url={api.usuarios.personal.select}
                //                         onChange={(data) => this.onChangeUsuario(data)}
                //                         value={this.state.usuarios} />
                //                 }
                //             />
                //         </Col>
                //     </Row>)
                // }
                outerFilter={outerFilter}
                apiUrl={api.imputaciones.imputaciones.participacion}
                columns={this.state.columns}
                // exportUrl={api.proyectos.cargadatos.participacion.export}
                title={"Participación en Imputaciones"}
            />
        );
    }
}

export default Imputaciones;


// WEBPACK FOOTER //
// ./src/views/Consultas/Imputaciones/Imputaciones.js